import * as React from 'react';

import {BuyFeatureConfigurationContext, frameworkBuyFeature} from './buyFeatureconfiguration';

const withBuyFeatureConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <BuyFeatureConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkBuyFeature}/>
                );
            }}
        </BuyFeatureConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withBuyFeatureConfiguration;